import SERVICE_URL from "../config/API_DATA";
import HttpPost from "../http/httppost.js";
import Logger from "./logger.js";
import { FILE_NAME, LOG_TYPE } from "../config/API_DATA";

export default class HotelGuestAge {
    static buildRequest(pGuestsAge,pHotelId) {
        let returnValue = null;
        try {
           let body=null;

           if(pGuestsAge )
             body ={
                "hotelId": pHotelId,
                "settingsid": pGuestsAge.settId,
                "ageGuestAgeFrom": pGuestsAge.guest.min,
                "ageGuestAgeTo": pGuestsAge.guest.max,
                "ageInfantAgeFrom": pGuestsAge.inf.min,
                "ageInfantAgeTo": pGuestsAge.inf.max,
                "ageChildAgeFrom": pGuestsAge.child.min,
                "ageChildAgeTo": pGuestsAge.child.max,
                "ageExtrabedAgeFrom":  pGuestsAge.extra.min,
                "ageExtrabedAgeTo":pGuestsAge.extra.max,
                "ageAllowchildExisingbed": pGuestsAge.allowChildBed
            } ;
            else
             throw 'invalid request'

            returnValue = body;
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_UPDATE_HOTEL_GUEST_AGE_SETUP,
                "error in building body for hotel age setup ",
                err.toString(),
                "buildRequest",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }

    static async getResponse(pReqOptions) {
        let returnValue = null;
        try {
            returnValue = await HttpPost.makeHttpPostRequest(
                SERVICE_URL.API_UPDATE_HOTEL_GUEST_AGE_SETUP,
                pReqOptions
            );
        } catch (err) {
            let body = Logger.buildRequest(
                FILE_NAME.API_UPDATE_HOTEL_GUEST_AGE_SETUP,
                "error in getting Response from update  hotel guest age setup ",
                err.toString(),
                "getResponse",
                LOG_TYPE.ERROR
            );
            Logger.getResponse(body);
        }
        return returnValue;
    }
}